import Transfer from './transfer.vue';
export default Transfer;


// WEBPACK FOOTER //
// ./src/components/transfer/index.js